import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Typography } from '@mui/material';
import React from 'react'

export default function ConfirmDialog({openAdmin, setOpenAdmin, handleMakeAdmin, item, message}) {
    return (
        <>
            <Dialog aria-labelledby='dialog-title' onClose={() => setOpenAdmin(false)} open={openAdmin}>
                <DialogTitle id='dialog-title'>
                    {message}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText style={{color: "red"}}>This action is irreversible!</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        color="secondary"
                        onClick={() => setOpenAdmin(false)}
                        variant="contained"
                        >Cancel</Button>
                    <Button
                        color="primary"
                        onClick={() => handleMakeAdmin({id: item._id})}
                        variant="contained"
                        >Yes</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}